import { openDB } from 'idb';
import { logError } from 'utils/datadog';

export const getDB = (dbName: string, version: number, storeName: string) => {
  try {
    return openDB(dbName, version, {
      upgrade(db) {
        if (!db.objectStoreNames.contains(storeName)) {
          db.createObjectStore(storeName);
        }
      }
    });
  } catch (error) {
    logError(`Failed to open database "${dbName}"`, error);
    throw error;
  }
};
